function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM19.0001 34.96C10.1856 34.96 3.04007 27.8145 3.04007 19C3.04007 10.1855 10.1856 3.04 19.0001 3.04C27.8145 3.04 34.9601 10.1855 34.9601 19C34.9601 27.8145 27.8145 34.96 19.0001 34.96ZM27.2136 13.7617L21.6087 19.3667L27.2136 24.9717C27.8327 25.5908 27.8327 26.5946 27.2136 27.2137C26.5945 27.8328 25.5907 27.8328 24.9716 27.2137L19.3667 21.6087L13.7617 27.2137C13.1426 27.8328 12.1389 27.8328 11.5198 27.2137C10.9006 26.5946 10.9006 25.5908 11.5198 24.9717L17.1247 19.3667L11.5197 13.7618C10.9006 13.1426 10.9006 12.1389 11.5197 11.5198C12.1388 10.9006 13.1426 10.9006 13.7617 11.5198L19.3667 17.1247L24.9716 11.5198C25.5907 10.9006 26.5945 10.9007 27.2136 11.5198C27.8327 12.1389 27.8327 13.1426 27.2136 13.7617Z",
  fill: "currentcolor"
});

const SvgSleep = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 38 38",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSleep, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sleep.d8899a2d.svg";
export { ForwardRef as ReactComponent };